import React from "react";
import ListGroup from "react-bootstrap/ListGroup";
import ListGroupItem from "react-bootstrap/ListGroupItem";
import { Link, useParams } from "react-router-dom";
import { CompanyAccess, TechnologicalMapProductRelationProxy } from "@me-team/host/main/graphql/types";
import { DeepPartial } from "@apollo/client/utilities";
import { WithRoleAccess } from "@services/ui-components";

interface TechnologicalMapsListProps {
    technologicalMaps: DeepPartial<TechnologicalMapProductRelationProxy[]>;
}

const TechnologicalMapsList: React.FC<TechnologicalMapsListProps> = ({ technologicalMaps }) => {
    const { currentCompanyId, branchId } = useParams();

    return (
        <>
            {technologicalMaps ? (
                <ListGroup>
                    {technologicalMaps?.map((techMap: TechnologicalMapProductRelationProxy, i: number) => (
                        <ListGroupItem key={techMap?.id}>
                            <span className="text-primary">{i + 1}. </span>
                            <WithRoleAccess
                                permission={CompanyAccess.TechMapProductListView}
                                fallback={<span>{techMap?.technologicalMap?.name}</span>}
                            >
                                <Link
                                    to={`/warehouse/technological-maps/${currentCompanyId}/${techMap?.technologicalMap?.id}/products/branch/${branchId}`}
                                    className="text-primary"
                                >
                                    {techMap?.technologicalMap?.name}
                                </Link>
                            </WithRoleAccess>
                        </ListGroupItem>
                    ))}
                </ListGroup>
            ) : null}
        </>
    );
};

export default TechnologicalMapsList;
